import React from 'react';
import PlaceholderBlock from '../../../PlaceholderBlock';
// spec says nothing about sizes of these, so arbitrary numbers
const splits = [
    [
        56,
        160
    ],
    [
        32,
        64
    ],
    [
        48,
        32
    ],
    [
        24,
        80
    ],
    [
        32,
        120
    ]
];
const TitlePlaceholder = ({ className, splitIndex = 0 })=>{
    const [width1, width2] = splitIndex < splits.length ? splits[splitIndex] : splits[0];
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(PlaceholderBlock, {
        width: width1,
        height: 8
    }), ' ', /*#__PURE__*/ React.createElement(PlaceholderBlock, {
        width: width2,
        height: 8
    }));
};
TitlePlaceholder.displayName = 'TitlePlaceholder';
export default TitlePlaceholder;
